import { CoinSponsorStatus, Quadkey, XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useContext, useEffect, useState } from 'react'

import { useGeotokensSettings } from '../../../Hooks'
import { AuthenticationContext } from '../../Authentication'
import Context from './Context'

interface Props {
  enabled?: boolean
  quadkey?: Quadkey
}

const Loader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { enabled = true } = props
  const { auth } = useContext(AuthenticationContext)
  const allSettingsList = useGeotokensSettings(auth?.token)
  const [filter, setFilter] = useState<CoinSponsorStatus>()
  const [settingsList, setSettingsList] = useState<XyoWorldGeotokenSettingsClient[]>()
  const [refreshCount, setRefreshCount] = useState(0)

  const updateFilter = (newFilter?: CoinSponsorStatus) => {
    if (filter !== newFilter) {
      setFilter(newFilter)
    }
  }

  useEffect(() => {
    if (enabled) {
      setSettingsList(
        allSettingsList?.filter((item) => {
          return filter === CoinSponsorStatus.All || item.getCoinSponsorStatus() === filter
        }),
      )
    }
  }, [allSettingsList, filter, refreshCount, enabled])

  const refresh = () => {
    setRefreshCount(refreshCount + 1)
  }

  return <Context.Provider value={{ filter, refresh, settingsList, updateFilter }}>{props.children}</Context.Provider>
}

export default Loader
